(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8726],{

/***/ 46687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _data_press_items_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48379);
/* harmony import */ var _components_landing_Press__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71723);
/* harmony import */ var _components_landing_Head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81519);
/* harmony import */ var _components_landing_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94964);
/* harmony import */ var _data_seo_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35546);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








var PRESS_DATA = _data_press_items_json__WEBPACK_IMPORTED_MODULE_0__.find(function (i) {
  return i.name === "datamynt-binance";
});

function DataMyntXBinance() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Head__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      SEO: _data_seo_json__WEBPACK_IMPORTED_MODULE_4__
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_landing_Press__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        item: PRESS_DATA,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "font-semibold text-lg",
          children: "Data Mynt\u2019s integration of Binance Chain (BNB), formerly Binance Smart Chain (BSC) in addition to enabling BNB and BUSD coins allows all owners of BNB-enabled wallets, BNB token and BUSD tokens to seamlessly pay or checkout in under 3 seconds with Data Mynt merchants and customers."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Oakland, CA (June 7, 2022) - Data Mynt, a leading provider of stable, omni-chain cryptocurrency merchant payments and checkout, announced a strategic partnership with Binance earlier this month. Binance is the developer of BNB Chain, BNB coin, BUSD coin and Binance exchange."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt\u2019s seller and merchant partners benefit from this integration by opening $70B in additional customer wallet value to them. BNB chain\u2019s block and payment settlement time is also ~3 seconds, which meets existing card purchasing experience expectations. Data Mynt also added: 1. BNB coin, which has $48b market cap or wallet asset value, and 2. BUSD stablecoin with its $18b in total wallet value available for payments."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "text-gray-50",
          children: ["These coins are now offered as a payment and settlement option for Data Mynt partners as the premier omni-chain payments solution that allows crypto users to pay and checkout using any BNB-enabled wallet or other wallets holding BEP-20, BNB, or BUSD coins. As a blockchain network, BNB smashed blockchain network statistical records in 2021 by recording 2.6 billion transactions among 126 million new wallets.", " "]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "This is Data Mynt\u2019s fifth blockchain ecosystem of new wallets and crypto assets integrated and enabled for payment and checkout. Now, between Polygon, ETH Mainnet, Bitcoin, Lightning Network and now BNB networks, over $800B in wallet asset value is available to Data Mynt partners, sellers and merchants."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "The Data Mynt patent-pending technology enables merchants and enterprises to expand their checkout payment options while allowing sellers and buyers to reduce payment processing costs and eliminate frictions such as chargebacks and crypto price volatility."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-gray-50",
            children: "\u201CBeing able to offer our partners and merchants a new global customer base as large as Binance and BNB is a game-changer especially in emerging markets\u201D"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "text-gray-50",
          children: ["Book a demo of Data Mynt\u2019s stable, omni-chain checkout payment solution powered", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
            href: "https://datamynt.com/contactus",
            target: "_blank",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary",
              children: "here"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About DataMynt"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt is the leading stable, omni-chain crypto payment checkout solution. Its suite of solutions offers partners and merchants an omnichannel approach to accepting crypto payments from any wallet free from volatility and the risks and costs of traditional payment methods. The Data Mynt crypto checkout payment solution is designed to streamline implementation via mobile Point of Sale, API, branded web page, and iFrame, while consistently delivering a seamless customer experience. DataMynt.com"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
          className: "flex space-x-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              target: "_blank",
              href: "https://datamynt.com",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Website"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              target: "_blank",
              href: "https://twitter.com/DataMynt",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Twitter"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              target: "_blank",
              href: "https://www.linkedin.com/company/datamynt/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "LinkedIn"
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About Binance BNB Chain"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "BNB Chain, one of the most popular blockchains in the world, is dedicated to delivering its core infrastructure necessary for future public adoption as a community-first and open-source ecosystem built on a permissionless and decentralized environment. The BNB dual-chain architecture empowers its users to build their decentralized apps and digital assets on one blockchain and take advantage of the fast trading to exchange on the other."
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (DataMyntXBinance);

/***/ }),

/***/ 85637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/datamynt-binance",
      function () {
        return __webpack_require__(46687);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,6111,9774,2888,179], function() { return __webpack_exec__(85637); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);